import { startTour } from "../globalSearch/annaBus";

// "Quick tour" in the account menu (StudentNav.js, N7). The tour (StudentTour.js) lives on the
// landing page, so from another page we go home with ?tour=1 and LandingPage starts it there.
// (StudentTour.js imports StudentNav.js, so StudentNav can't import it back: same id here.)
export const TOUR_ID = "student-quick-tour";
export const TOUR_PARAM = "tour";

export const replayStudentTour = (navigate) => {
  if (window.location.pathname === "/") {
    startTour(TOUR_ID);
    return;
  }
  navigate(`/?${TOUR_PARAM}=1`);
};

/** LandingPage: was the tour asked for in the address? Removes the flag either way. */
export const takeTourRequest = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get(TOUR_PARAM) !== "1") return false;
  params.delete(TOUR_PARAM);
  const rest = params.toString();
  window.history.replaceState(window.history.state, "", `${window.location.pathname}${rest ? `?${rest}` : ""}${window.location.hash}`);
  return true;
};
